import './assets/fonts/fonts.css'
import { initAnalytics, pageview, identify } from './lib/analytics/client'
import { AnalyticsConsent } from './lib/analytics/Consent'
import type { Session } from './lib/session'
import '@fontsource-variable/geist-mono'
import './styles/globals.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { AppProviders } from './app/providers'
import { appSurface } from './app/pricing/surface'

async function boot() {
  // `VITE_MOCK_API=1 npm run dev:web` serves a fake session + workspaces so
  // the shell can be exercised before the API exists. Never in production.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1') {
    const { installMockApi } = await import('./dev/mockApi')
    installMockApi()
  }
  initAnalytics({ token: import.meta.env.VITE_POSTHOG_TOKEN, host: import.meta.env.VITE_POSTHOG_HOST, environment: import.meta.env.VITE_ANALYTICS_ENV, testRunId: import.meta.env.VITE_ANALYTICS_TEST_RUN, surface: appSurface() })
  // pricing.* hosts get the broker pricing site; only the chosen router (and its route tree) loads.
  const { queryClient, router } = appSurface() === 'pricing' ? await import('./app/pricing/router') : await import('./app/router')
  router.subscribe('onResolved', () => pageview())
  const syncIdentity = () => {
    const session = queryClient.getQueryData<Session | null>(['session'])
    if (session) identify(session.user.id, Boolean(session.platformRole))
    else if (session === null) identify(undefined)
  }
  queryClient.getQueryCache().subscribe(syncIdentity)
  window.addEventListener('smkt:analytics-consent', syncIdentity)
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders queryClient={queryClient}>
        <RouterProvider router={router as never} />
        <AnalyticsConsent />
      </AppProviders>
    </StrictMode>,
  )
}

void boot()
